const RentalPages = {

    init() {
        this.setInteractionObserver();
    },

    setInteractionObserver() {

        const elements = document.querySelectorAll('.io');
        const headerClasses = ['[component="Header"]', '[section="tabs"]'];
        let combinedHeaderHeight = 0;

        // Calculate the combined height of all fixed headers with different classes
        headerClasses.forEach(headerClass => {
            const headers = document.querySelectorAll(headerClass);
            headers.forEach(header => {
                combinedHeaderHeight += header.offsetHeight;
            });
        });

        const options = {
            root: null, // Nastavit na null, pokud chceme sledovat viditelnost v celém viewportu
            rootMargin: `-${combinedHeaderHeight}px 0px 0px 0px`, // Okraje kolem cílového prvku, na kterých závisí aktivace pozorování
            threshold: 0.2 // Hodnota od 0.0 do 1.0, která určuje, kolik procent prvek musí být viditelný, aby došlo k aktivaci
        };

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Prvek vstoupil do viewportu nebo na něj překrývá
                    // Zde můžete provést akce, které mají být provedeny, když je prvek viditelný
                    //console.log('Prvek je viditelný');

                    // if (entry.target.nodeName === 'IMG') {
                    //     App.showImage(entry.target);
                    //     entry.target.classList.add('loaded');
                    //     $(entry.target).parent().addClass('loaded');
                    // }

                    entry.target.classList.add('ioVisible');
                } else {
                    // Prvek opustil viewport
                    // Zde můžete provést akce, které mají být provedeny, když prvek není viditelný
                    //console.log('Prvek není viditelný');
                    entry.target.classList.remove('ioVisible');
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        elements.forEach((element) => {
            observer.observe(element);
        });
    },
}

export default RentalPages;